"use client"

import { createContext, useContext, useState, useCallback } from "react"
import type { FilterSearchHome } from "../hooks/filter-search-homes.hook"

type FilterSearchExportContextType = {
    filteredHomesForExport: FilterSearchHome[] | null
    setFilteredHomesForExport: (homes: FilterSearchHome[] | null) => void
}

const FilterSearchExportContext = createContext<FilterSearchExportContextType>({
    filteredHomesForExport: null,
    setFilteredHomesForExport: () => {},
})

export function FilterSearchExportProvider({ children }: { children: React.ReactNode }) {
    const [filteredHomesForExport, setFilteredHomesForExport] = useState<FilterSearchHome[] | null>(null)
    return (
        <FilterSearchExportContext.Provider value={{ filteredHomesForExport, setFilteredHomesForExport }}>
            {children}
        </FilterSearchExportContext.Provider>
    )
}

export function useFilterSearchExport() {
    const context = useContext(FilterSearchExportContext)
    if (!context) {
        throw new Error("useFilterSearchExport must be used within FilterSearchExportProvider")
    }
    return context
}
